import { render } from "./ModeratorSearch.vue?vue&type=template&id=5e08e092&scoped=true"
import script from "./ModeratorSearch.vue?vue&type=script&lang=js"
export * from "./ModeratorSearch.vue?vue&type=script&lang=js"

import "./ModeratorSearch.vue?vue&type=style&index=0&id=5e08e092&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e08e092"]])

export default __exports__